import { QueryClient, type QueryClientConfig } from '@tanstack/react-query';
import { type PersistQueryClientProviderProps } from '@tanstack/react-query-persist-client';

import { createPersister } from './indexed-db';

const PERSISTED_QUERY_MAX_AGE_MS = 1000 * 60 * 60 * 12;

const queryClientConfig: QueryClientConfig = {
    defaultOptions: {
        queries: {
            retry: 0,
            staleTime: 1000 * 60 * 5,
            gcTime: 1000 * 60 * 60 * 24,
            refetchOnWindowFocus: true,
            refetchOnReconnect: 'always',
            networkMode: 'offlineFirst',
        },
        mutations: {},
    },
};

export const queryClient = new QueryClient(queryClientConfig);

const persister = createPersister();

export const persistOptions: PersistQueryClientProviderProps['persistOptions'] = {
    persister,
    maxAge: PERSISTED_QUERY_MAX_AGE_MS,
    dehydrateOptions: {
        shouldDehydrateQuery: (query) => {
            return query.meta?.persist === true && query.state.status === 'success';
        },
        shouldDehydrateMutation: () => false,
        // Needed for offline mutations support
        // shouldDehydrateMutation: (mutation) => {
        //     const dehydrate = mutation.options.mutationKey?.some(() => {
        //         // Add mutations that should be dehydrated
        //     });

        //     return dehydrate ?? false;
        // },
    },
};

export { onlineManager } from '@tanstack/react-query';
export { ReactQueryDevtools } from '@tanstack/react-query-devtools';
export { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
